// extracted by mini-css-extract-plugin
module.exports = {"lens":"SearchBar_lens__Cl6zb","fullWidth":"SearchBar_fullWidth__saLAE","icon":"SearchBar_icon__6MPzz","active":"SearchBar_active__aakFD"};